<template>
  <v-container
    fluid
    style="background-color: white; color: black; height: 100vh;"
  >
    <v-row>
      <v-col cols="12">
        <v-spacer />
        <v-btn
          color="orange"
          depressed
          right
          @click="print('printAbleArea')"
        >
          <v-icon
            left
            small
          >
            fas fa-print
          </v-icon>
          พิมพ์
        </v-btn>
      </v-col>
    </v-row>
    <div id="printAbleArea">
      <h1>ร้าน Relief Spa & Massage</h1>
      <small>24/2 ถนนนิวาศ อําเภอเมือง จังหวัดบุรีรัมย์ รหัสไปรษณีย์ 31000</small>
      <div
        v-if="this.$route.query.week === 'TRUE'"
        style="margin-top: 16px; margin-bottom: 16px;"
      >
        <center>
          <h3>
            รายงานรายรับระหว่างวันที่ {{ this.$route.query.startDate.replace(/-/g, '/') }}
            ถึง {{ this.$route.query.endDate.replace(/-/g, '/') }}
          </h3>
          <span>รวม {{ amount }} บาท</span>
        </center>
      </div>
      <div
        v-else
        style="margin-top: 16px; margin-bottom: 16px;"
      >
        <center>
          <h3>
            รายงานรายประจำวันที่ {{ this.$route.query.date.replace(/-/g, '/') }}
          </h3>
          <span>รวม {{ amount }} บาท</span>
        </center>
      </div>
      <v-simple-table
        class="my-2 theme--light"
        light
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">
                ชื่อ - นามสกุล ลูกค้า
              </th>
              <th class="text-center">
                บริการ
              </th>
              <th class="text-center">
                บริการคอร์ส
              </th>
              <th class="text-center">
                รวม
              </th>
            </tr>
          </thead>
          <tbody v-if="reservations.length > 0">
            <tr
              v-for="reservation in reservations"
              :key="reservation._id"
            >
              <td>
                {{ reservation.customer.firstName }}
                {{ reservation.customer.lastName }}
              </td>
              <td v-if="reservation.services.length > 0">
                <span
                  v-for="(service, index) in reservation.services"
                  :key="service._id"
                >
                  {{ service.name }}
                  [ {{ service.price }} บาท ]
                  <template v-if="index + 1 !== reservation.services.length">
                    ,
                  </template>
                </span>
              </td>
              <td v-else>
                -
              </td>
              <td v-if="reservation.courses.length > 0">
                <span
                  v-for="(course, index) in reservation.courses"
                  :key="course._id"
                >
                  {{ course.name }}
                  [ {{ course.price }} บาท ]
                  <template v-if="index + 1 !== reservation.courses.length">
                    ,
                  </template>
                </span>
              </td>
              <td v-else>
                -
              </td>
              <td>{{ reservation.price }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">
                <center>
                  <v-icon
                    left
                    small
                  >
                    fas fa-dizzy
                  </v-icon>
                  ไม่พบข้อมูล
                </center>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment';
import http from '@/http';

export default {
  name: 'WeeklyIncomeReport',
  data() {
    return {
      reservations: [],
      amount: 0,
    };
  },
  async created() {
    if (this.$route.query.week === 'TRUE') {
      const weekReport = await http.get(
        `/reports?startDate=${moment(this.$route.query.startDate).valueOf()}&endDate=${moment(this.$route.query.endDate).valueOf()}`,
      );
      this.reservations = [...weekReport.data.reservations];
      this.amount = weekReport.data.amount;
    } else {
      const start = moment(this.$route.query.date).valueOf();
      const end = moment(this.$route.query.date).add(1439, 'minutes').valueOf();
      const { data } = await http.get(`/reports?startDate=${start}&endDate=${end}`);
      this.reservations = [...data.reservations];
      this.amount = data.amount;
    }
  },
  methods: {
    print(divName) {
      const printContents = document.getElementById(divName).innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      window.close();
      document.body.innerHTML = originalContents;
    },
  },
};
</script>

<style scoped>
@page {
  size: 21cm 29.7cm;
  margin: 1cm;
};
@media print {
  * {
    font-family: 'Kanit';
  }
}
</style>
